// This file has all the extra stuff we need to include
// VUE, VUE_ROUTER, VFG, Vue_scrollto

import Vue from "vue";

import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

// Sentry.init({
//   dsn: "https://fece83e07af947a9b54f6847c60a4fac@sentry.io/222945",
//   release: "0.8.32+",
//   integrations: [
//     new Integrations.Vue({
//       Vue,
//       attachProps: true
//     })
//   ]
// });

import VueRouter from "vue-router";
import VueFormGenerator from "vue-form-generator";

// import Autocomplete from 'v-autocomplete';
var VueScrollTo = require("vue-scrollto").default;

// TODO don't think this is needed any more?
const vueFeathers = require("vue-feathers").default; // surface all services to all components
Vue.use(VueRouter, vueFeathers, VueFormGenerator, VueScrollTo);

window.VueFormGenerator = VueFormGenerator; // needed for form validators
window.Vue = Vue;

// JQUERY
var jQuery = require("jquery");
window.$ = window.jQuery = window.jquery = jQuery;

// NAVGOCO
var navgoco = require("../plugins/navgoco/jquery.navgoco.min.js");
window.navgoco = navgoco;

// eonasdan-bootstrap-DATETIMEPICKER
var datetimepicker = require("eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js");
window.datetimepicker = datetimepicker;

// TWITTER BOOTSTRAP
require("bootstrap");

// TEMPLATE LEGACY JS
var appLegacy = require("./appLegacy");
window.appLegacy = appLegacy;
